import { useLocation } from 'react-router-dom';
import { selectBuildById } from '../reducers/savedBuild';
import { useAppSelector } from '../utils';
const useBapGetBuildData = () => {
    const { search } = useLocation();
    const query = new URLSearchParams(search);
    const queryBuildId = query.get('buildId');
    return useAppSelector(state => selectBuildById(state, queryBuildId));
};
export default useBapGetBuildData;
